import { Link } from 'react-router-dom';
import { HelpCircle, ArrowRight } from 'lucide-react';
import { faqs } from '../data/siteData';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../components/ui/accordion';
import { Button } from '../components/ui/button';

export default function FAQPage() {
  return (
    <div data-testid="faq-page" className="pt-20">
      {/* Header */}
      <section className="py-16 md:py-24 bg-[#F8F9FA]">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="flex items-center gap-4 mb-6">
            <div className="w-14 h-14 bg-[#47ace2]/10 rounded-2xl flex items-center justify-center">
              <HelpCircle className="w-7 h-7 text-[#47ace2]" />
            </div>
          </div>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-light tracking-tight text-slate-900 font-outfit">
            Frequently Asked Questions
          </h1>
          <p className="text-lg text-slate-600 font-manrope mt-4 max-w-2xl">
            Find answers to common questions about our projects, services, and buying process.
          </p>
        </div>
      </section>

      {/* FAQ Content */}
      <section className="py-16 md:py-24">
        <div className="max-w-3xl mx-auto px-6 md:px-12">
          <Accordion type="single" collapsible className="space-y-4">
            {faqs.map((faq, index) => (
              <AccordionItem
                key={index}
                value={`item-${index}`}
                data-testid={`faq-${index}`}
                className="bg-white border border-slate-100 rounded-2xl px-6 shadow-sm"
              >
                <AccordionTrigger className="text-left font-semibold text-slate-900 font-outfit py-6 hover:no-underline">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-slate-600 font-manrope pb-6">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </section>

      {/* Still Have Questions */}
      <section className="py-16 md:py-24 bg-[#F0F8FF]">
        <div className="max-w-3xl mx-auto px-6 md:px-12 text-center">
          <h2 className="text-3xl md:text-4xl font-light tracking-tight text-slate-900 font-outfit mb-6">
            Still Have Questions?
          </h2>
          <p className="text-slate-600 font-manrope mb-8">
            Can't find the answer you're looking for? Our team is here to help.
          </p>
          <Link to="/contact">
            <Button className="bg-[#47ace2] hover:bg-[#1f7db3] rounded-full px-8">
              Contact Us
              <ArrowRight className="w-4 h-4 ml-2" />
            </Button>
          </Link>
        </div>
      </section>
    </div>
  );
}
